export default __webpack_public_path__ + "assets/img/course.6d4c727b1de6d5ff500d83fc44001e1f.png";